import {getheaders} from "./authService";

export async function getAllWebhookConnections() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/guesty/webhook", requestOptions);
}

export async function getWebhookConnectionByCustomerId(cosCustomerId) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook?cosCustomerId=${cosCustomerId}`, requestOptions);
}

export async function upsertWebhookConnection(webhookData) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(webhookData)
    };

    return fetch("/api/guesty/webhook/upsert", requestOptions);
}

export async function deleteWebhookConnection(cosCustomerId, webhookId) {
    let requestOptions = {
        method: 'DELETE',
        headers: getheaders(),
        redirect: 'follow'
    };

    // If webhookId is provided, delete a specific webhook
    // Otherwise, delete all webhooks for the customer (backward compatibility)
    const url = webhookId 
        ? `/api/guesty/webhook/${cosCustomerId}/${webhookId}` 
        : `/api/guesty/webhook/${cosCustomerId}`;
        
    return fetch(url, requestOptions);
}

export async function getGuestyWebhookMessages(cosCustomerId = null) {
    let url = "/goapi/guesty/webhook-messages";
    
    if (cosCustomerId) {
        url += `?cosCustomerId=${cosCustomerId}`;
    }
    
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(url, requestOptions);
}

export async function getGuestyWebhookMessageById(id) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook-messages/${id}`, requestOptions);
}

export async function getGuestyRawWebhookMessageById(id) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook-messages/raw/${id}`, requestOptions);
}

export async function getGuestyFailedMessagesCount() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/guesty/webhook-messages/failed/count", requestOptions);
}

export async function toggleGuestyMessageStatus(id, forceStatus = null) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow'
    };

    // If forceStatus is provided, add it to the request body
    if (forceStatus) {
        requestOptions.body = JSON.stringify({ targetStatus: forceStatus });
        requestOptions.headers.append("Content-Type", "application/json");
    }

    return fetch(`/api/guesty/webhook-messages/${id}/toggle-status`, requestOptions);
}

export async function getAllCustomers() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/user/customers", requestOptions);
}

export async function login(username, password) {

    let loginheaders = new Headers();
    loginheaders.append("Content-Type", "application/json");

    let requestOptions = {
        method: 'POST', headers: loginheaders,
        body: JSON.stringify({
            username: username,
            password: password
        })
    };

    return fetch("/api/login", requestOptions)
}

export async function getAllUsers() {
    return getUsers({include: ['location_tracking']});
}

export async function getUsers({roles = [], accountStates = [], include = []} = {}) {
    const params = new URLSearchParams();
    if (roles.length > 0) params.set('roles', roles.join(','));
    if (accountStates.length > 0) params.set('account_states', accountStates.join(','));
    if (include.length > 0) params.set('include', include.join(','));

    const requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };

    const query = params.toString();
    return fetch(`/goapi/users${query ? `?${query}` : ''}`, requestOptions)
}

export function getUsersFromPayload(payload) {
    return Array.isArray(payload) ? payload : payload?.users || [];
}

export function toFieldWorker(user) {
    return {
        id: user.cos_customer_id,
        userId: user.user_id,
        username: user.username,
        email: user.email,
        name: user.cos_customer_name,
        role: user.role,
        region: user.region,
        accountState: user.account_state,
        isDeleted: user.account_state !== 'ACTIVE',
        locationTracking: user.location_tracking || null,
    };
}

export function getDirectoryEntriesByRole(payload, role) {
    return getUsersFromPayload(payload)
        .filter(user => user.role === role)
        .map(toFieldWorker);
}

export function mapDirectoryEntriesById(entries) {
    return entries.reduce((directory, entry) => {
        directory[entry.id] = entry.isDeleted ? `${entry.name} (Inactive)` : entry.name;
        return directory;
    }, {});
}

export async function getFieldWorkers() {
    return getUsers({roles: ['WORKER']});
}

export async function getSuperVisor() {
    return getUsers({roles: ['SUPERVISOR']});
}

export async function getUserbyUsername(username) {

    let myHeaders = getheaders();

    let requestOptions = {
        method: 'GET', headers: myHeaders, redirect: 'follow'
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function changeUserDetail(username, userdetails) {

    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function setAgencyBlocked(cosCustomerId, blocked) {
    return fetch(`/api/user/agencies/${encodeURIComponent(cosCustomerId)}/blocked`, {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({blocked})
    });
}

export async function getAllowedRegion() {

    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/user/allowedRegion", requestOptions)
}

export async function addNewUser(userdetails) {

    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user", requestOptions)
}

export async function getAgencies() {
    return fetch("/api/user/agencies", {
        method: "GET", headers: getheaders(), redirect: "follow"
    });
}

export async function getPropertyManagerAccess(username) {
    return fetch(`/api/user/${encodeURIComponent(username)}/property-access`, {
        method: "GET", headers: getheaders(), redirect: "follow"
    });
}

export async function updatePropertyManagerAccess(username, access) {
    return fetch(`/api/user/${encodeURIComponent(username)}/property-access`, {
        method: "PUT",
        headers: getheaders(),
        redirect: "follow",
        body: JSON.stringify(access)
    });
}

export async function updateWebhookFilterMode(webhookId, filterMode) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({ filter_mode: filterMode })
    };

    return fetch(`/api/guesty/webhook/filter_mode/${webhookId}`, requestOptions);
}
